module.exports = __webpack_public_path__ + "img/baitaomoliyanwobing.19787880.jpg";